import { round } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import Checkbox from '../../../../components/forms/Checkbox'
import Input from '../../../../components/forms/Input'
import NumberField from '../../../../components/forms/NumberField'
import Select from '../../../../components/forms/Select'
import Textarea from '../../../../components/forms/Textarea'
import { getDefaultValuesChoiceModal, getMatTypes } from '../../../../utils/MaterielUtils'
import GenericReferencialDto from '../../../dto/GenericReferencialDto'
import PowerSupplyTypeDto from '../../powerSupply/dto/PowerSupplyTypeDto'
import SensorDto from '../dto/SensorDto'
import { Grid } from '@mui/material'

const SensorEquipmentPanel = ({
    active = false,
    disabled = true,
    sensor = {},
    displaySupply = true,
    sensorTypes = [],
    powerSupplyTypes = [],
    onChange = () => { },
}) => (
    <Grid size={12} sx={{ marginBottom: 1 }}>
        <Grid container sx={{ paddingTop: '3px' }}>
            <Grid size={4}>
                <Select
                    options={getMatTypes(sensorTypes, sensor.sensorType)}
                    label={i18n.type}
                    onChange={value => {
                        onChange({ sensorType: value })
                        getDefaultValuesChoiceModal(sensorTypes.find(c => c.materielType == value), onChange)
                    }}
                    value={sensor.sensorType}
                    nullLabel='&nbsp;'
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ paddingTop: '3px' }}>
            <Grid size={6}>
                <Input
                    title={i18n.scaleInBar}
                    value={sensor.range}
                    onChange={value => onChange({ range: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
            <Grid size={6}>
                <NumberField
                    title={i18n.lengthInMetter}
                    value={sensor.length}
                    onChange={value => onChange({ length: round(value, 2) })}
                    active={active}
                    disabled={disabled}
                    floatValue
                />
            </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ alignItems: displaySupply ? 'center' : undefined, paddingTop: '3px' }}>
            {
                displaySupply && (
                    <Grid container size={9} spacing={1}>
                        <Grid size={4}>
                            <Select
                                options={getMatTypes(powerSupplyTypes, sensor.powerSupplyType)}
                                label={i18n.powerSupplyType}
                                onChange={value => onChange({ powerSupplyType: value })}
                                value={sensor.powerSupplyType}
                                nullLabel='&nbsp;'
                                active={active}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid size={4}>
                            <NumberField
                                title={i18n.batteryCount}
                                value={sensor.pileNumber}
                                onChange={value => onChange({ pileNumber: value })}
                                active={active}
                                disabled={disabled}
                            />
                        </Grid>
                        <Grid size={4}>
                            <NumberField
                                title={i18n.supplyTime}
                                value={sensor.supplyTime}
                                onChange={value => onChange({ supplyTime: value })}
                                active={active}
                                disabled={disabled}
                            />
                        </Grid>
                    </Grid>
                )
            }
            <Grid size={3}>
                <Checkbox
                    label={i18n.desiccant}
                    checked={sensor.desiccant === '1'}
                    onChange={e => onChange({ desiccant: e ? '1' : '0' })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
        <Grid container sx={{ paddingTop: '8px' }}>
            <Grid size={12}>
                <Textarea
                    title={i18n.comment}
                    value={sensor.comment}
                    onChange={value => onChange({ comment: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
    </Grid>
)

SensorEquipmentPanel.propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onChange: PropTypes.func,
    displaySupply: PropTypes.func,
    sensor: PropTypes.instanceOf(SensorDto),
    sensorTypes: PropTypes.instanceOf(GenericReferencialDto),
    powerSupplyTypes: PropTypes.arrayOf(PropTypes.instanceOf(PowerSupplyTypeDto)),
}

const mapStateToProps = store => ({
    sensorTypes: store.SensorReducer.sensorTypes,
    powerSupplyTypes: store.PowerSupplyReducer.powerSupplyTypes,
})

export default connect(mapStateToProps)(SensorEquipmentPanel)
